import axios from 'axios';

const httpGetCaptchaSiteKey = () => {
  return axios.get('/api/v2/captcha/sitekey');
};

export { httpGetCaptchaSiteKey };
